import axios from "axios";
import { Response } from "@/shared/models/Response";
import { Session } from "../../Profile/models/Session";
import { SessionIntelliticks } from "@/modules/WebViews/GroupTypeService/models/SessionIntelliticks";

export class SessionService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/sessions`;
  }

  async getSessionById(sessionId: string): Promise<Response<Session>> {
    const serviceUrl = `${this.baseUrl}/get-session-by-id/${sessionId}`;
    const response = await axios.get(serviceUrl);
    return response.data;
  }

  async updateSession(
    userId: string,
    sessionUpdate: SessionIntelliticks
  ): Promise<Response<Session>> {
    const serviceUrl = `${this.baseUrl}/save-update-session/${userId}`;
    const response = await axios.post(serviceUrl, sessionUpdate);
    return response.data;
  }
}
